import RadioButton from 'scripts/defa/basic/view-radio-button-view';
import template    from 'templates/subscriptionPackageRadioButton.jst.html';

/**
 * defa.views.SubscriptionPackageRadioButton
 * An advanced block-radio-button for SubscriptionPackages.
 * @version 1.2.0
 */
const SubscriptionPackageRadioButton = RadioButton.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template  : template,
	tagName   : 'label',
	className : 'payment-block',
	
	templateContext: function() {
		return {
			installerAddress: this._getInstallerAddress() || false,
			prepaid: this.options.prepaid,
		}
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the view first renders.
	 * @void
	 */
	onRender: function () {
		const self = this;
		
		if ( self.model.get( 'promotionCode' ) ) {
			setTimeout( function () {
				
				self.$el.addClass( 'promotional' );
			}, 200 );
		}
	},
	
	/**
	 * Triggers when the input[type=radio-button] is changed.
	 * @overwrite
	 * @void
	 */
	onChangeInput: function () {
		this.$el.siblings().removeClass( 'checked' ).removeClass( 'open' );
		this.$el.addClass( 'checked' ).addClass( 'open' );
		
		this.trigger( 'selected', this );
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Returns either company name or email address, depending on the installers invoiceTypes preference.
	 * @return {string} The company name or email address.
	 */
	_getInstallerAddress: function () {
		if ( this.options.installer ) {
			return ( _.contains( this.options.installer.get( 'invoiceTypes' ), 'EMAIL' ) )
				   ? this.options.installer.get( 'invoiceEmail' )
				   : this.options.installer.name();
		} else {
			return false
		}
	},
	
} );

export default SubscriptionPackageRadioButton;